<div class="date-picker-field">
  <div class="dp-hidden position-absolute">
    <label
      for="datepicker"
      class="visually-hidden"
      >Date picker</label
    >
    <div
      class="input-group"
      [ngClass]="{ 'is-invalid': displayIsRequired }">
      <input
        id="datepicker"
        name="datepicker"
        class="form-control"
        ngbDatepicker
        #datepicker="ngbDatepicker"
        [autoClose]="'outside'"
        (dateSelect)="onDateSelection($event)"
        navigation="select"
        [displayMonths]="2"
        [dayTemplate]="t"
        outsideDays="hidden"
        [startDate]="fromDateSignal()!"
        [footerTemplate]="footerTemplate"
        [minDate]="minDateConverted()"
        [maxDate]="maxDateConverted()"
        tabindex="-1"
        placeholder="Select dates"
        [ngClass]="{ 'disable-previous': isPrevDisabled() }" />
      <ng-template
        #t
        let-date
        let-focused="focused">
        <div
          class="custom-day"
          [class.focused]="focused"
          [class.range]="isRange(date)"
          [class.faded]="isHovered(date) || isInside(date)"
          (mouseenter)="hoveredDate = date"
          (mouseleave)="hoveredDate = undefined">
          {{ date.day }}
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <hr class="my-0" />
        <div class="p-2">
          <div class="row gx-2 flex-nowrap">
            <div class="col">
              <button
                type="button"
                class="btn btn-outline-dark btn-sm"
                (click)="resetCalendar()">
                Reset
              </button>
            </div>
            <div class="col-auto ms-auto">
              <button
                type="button"
                class="btn btn-secondary btn-sm"
                (click)="closeCalendar(datepicker, $event)">
                Confirm
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <button
    type="button"
    class="input-group flex-nowrap btn-reset"
    (click)="datepicker.toggle()">
    <label
      for="calendarInputField"
      class="visually-hidden"
      >Date picker</label
    >
    <input
      id="calendarInputField"
      #dpFromDate
      class="form-control"
      placeholder="Select date"
      name="dpFromDate"
      [ngClass]="{ 'is-invalid': displayIsRequired }"
      [readonly]="true"
      [disabled]="disabled"
      [value]="
        fromDateSignal() || toDateSignal()
          ? formatter.format(fromDateConverted()!) + ' - ' + formatter.format(toDateSignal()!)
          : ''
      "
      (input)="validateInput(fromDateConverted()!, dpFromDate.value)" />
    <span
      class="input-group-text"
      [ngClass]="{ 'is-invalid': displayIsRequired }">
      <i class="iconoir-calendar"></i>
    </span>
  </button>
</div>
